import React, { Component } from 'react';
import SERVER_URL from '../Global';
import { Affix, Breadcrumb, Icon, message, Popover } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import { Input, Avatar } from 'antd';
import { GeoCardDetail } from './GeoCardDetail';

export class GeoList extends Component {
    static displayName = GeoList.name;

    constructor(props) {
        super(props);

        this.state = {
            user: this.props.token,
            places: [],
            loading: true,
            hasDetail: false,
            detailGeo: [],
            maxPageSize: '',
            searchName: '',
            detailIndex: '',
            pageNumber: 1
        };

        this.getDetail = this.getDetail.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.deleteGeo = this.deleteGeo.bind(this);
        this.infiniteScroll = this.infiniteScroll.bind(this);

        document.title = "Polar - Places"
    }

    componentDidMount() {
        fetch(
            `${SERVER_URL + 'api/city/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 40,
                    "pageSizeOptions": null,
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "ordering": {
                        "orderPropertyName": "name",
                        "order": 1
                    },
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ places: res.data, loading: false, maxPageSize: res.params.totalPages, });
                }
            })
    }

    handleSearch() {
        fetch(
            `${SERVER_URL + 'api/city/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": this.state.searchName,
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 40,
                    "pageSizeOptions": null,
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "ordering": {
                        "orderPropertyName": "name",
                        "order": 1
                    },
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ places: res.data, loading: false });
                }
            })
    }

    getDetail(geo, i) {
        this.setState({ detailGeo: geo, hasDetail: true, detailIndex: i })
    }

    deleteGeo() {
        //funzione finale
        fetch(`${SERVER_URL + 'api/city/hard/' + this.state.detailGeo.cityId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`
            }
        }).then(response => response.json())
        .then(res => {
            if (res.ok) {
                this.setState({ hasDetail: false, detailGeo: [] })

                fetch(
                    `${SERVER_URL + 'api/city/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "name": this.state.searchName,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "ordering": {
                            "orderPropertyName": "name",
                            "order": 1
                        },
                        "entityId": 0
                    })
                }
                ).then(response => response.json())
                    .then(res => {
                        if (res.data != null) {
                            this.setState({ places: res.data, loading: false });
                        } else {
                            this.setState({ places: [], loading: false });

                        }
                    })
            } else {
                message.warning("This city can't be deleted because it's already been used")
            }
        })
    }

    infiniteScroll(e) {
        const fondo = e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 3;
        if (fondo && this.state.maxPageSize > this.state.pageNumber) {
            let newPage = this.state.pageNumber + 1
            this.setState({ loadingBelow: true });
            fetch(
                `${SERVER_URL + 'api/city/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": this.state.searchName,
                    "page": newPage,
                    "pageSize": 40,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": this.state.orderBy,
                        "order": this.state.order
                    }
                })
            }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ places: this.state.places.concat(res.data), loading: false, pageNumber: newPage });
                    }
                    else {
                        this.setState({ loading: false, pageNumber: newPage });
                    }
                })
        }
    }

    handleNameChange(event) {
        this.setState({ searchName: event.target.value });
        if (event.target.value.length > 1 || event.target.value.length == 0) {
            this.setState({ loading: true })
            fetch(
                `${SERVER_URL + 'api/city/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "name": event.target.value,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": this.state.orderBy,
                            "order": this.state.order
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ places: res.data, loading: false, maxPageSize: res.params.totalPages, pageNumber: 1 });
                    }
                    else {
                        this.setState({ loading: false, places: [], pageNumber: 1 });
                    }
                })
        }
    }

    render() {

        let tableContent = this.state.loading ?
            <tr className="spinContainer">
                <td>
                    <Icon type="loading" style={{ fontSize: 114, color: '#1890ff' }} spin />
                </td>
            </tr>
            :
            this.state.places.length == 0 ?
                null
                :
                this.state.places.map((geo, i) => {
                    return (
                        <tr onScroll={this.infiniteScroll} key={geo.cityId}>
                            <td className="categoryNameList" onClick={() => this.getDetail(geo, i)}>{geo.province.region.nation.name}</td>
                            <td className="categoryNameList" onClick={() => this.getDetail(geo, i)}>{geo.province.region.name == "§N.A.§" ? "N/A" : geo.province.region.name}</td>
                            <td className="categoryNameList" onClick={() => this.getDetail(geo, i)}>{geo.province.name == "§N.A.§" ? "N/A" : geo.province.name}</td>
                            <td onClick={() => this.getDetail(geo, i)}>{geo.name}</td>
                            <td onClick={() => this.getDetail(geo, i)}>{geo.brCityZipCodes.map((br, i) => {
                                if (i < 5 && i + 1 < geo.brCityZipCodes.length) {
                                    return <span key={br.zipCodeId}>{br.zipCode.value}, </span>
                                } else if (i == 5) {
                                    return <span key={br.zipCodeId}>{br.zipCode.value}  [...]</span>
                                } else if (i < 5 && i + 1 == geo.brCityZipCodes.length) {
                                    return <span key={br.zipCodeId}>{br.zipCode.value}</span>
                                }
                            }
                            )}</td>
                        </tr>
                    )
                })

        let detailLoaded = this.state.hasDetail ? <GeoCardDetail delete={this.deleteGeo} geo={this.state.detailGeo} /> : ''

        let noPlaces = this.state.places.length == 0 ?
            <div className="noHr">
                <h3>No City found</h3>
            </div> : null

        return (
            <Container fluid={true}>
                <Row>
                    <Col sm="12" style={{ display: 'inline-flex', height: 0 }}>
                        <Breadcrumb className="bread">                            
                            <Breadcrumb.Item>Places</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="plusButtonCat">
                            <a style={{ marginRight: '10px' }} className="button create" href="/places/create" ><Icon type="plus" /></a>
                        </div>

                        <div className="ant-breadcrumb searchList cat midSearchBar">
                            <Input autoComplete="new-password" placeholder="Search Cities" style={{ width: '100%', marginTop: '-1em' }} allowClear={true} value={this.state.searchName} onChange={this.handleNameChange} />
                            <Icon className="homeViewSearch" onClick={this.handleSearch} type="search" />
                        </div>
                    </Col>

                    <Col sm="9" onScroll={this.infiniteScroll} className="mainBoard">

                        <div className="tableContainer">
                            <table className='table table-striped'>
                                <thead>
                                    <tr>
                                        <th style={{ width: '15%' }}>Nation</th>
                                        <th style={{ width: '15%' }}>Region</th>
                                        <th style={{ width: '15%' }}>Province</th>
                                        <th style={{ width: '25%' }}><p style={{ whiteSpace: "nowrap", marginBottom: '0' }}>City</p></th>
                                        <th style={{ width: '30%' }}><p style={{ whiteSpace: "nowrap", marginBottom: '0' }}>ZipCode</p></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableContent}
                                </tbody>
                            </table>
                            {noPlaces}
                        </div>

                    </Col>
                    <Col sm="3">
                        <Affix offsetTop={this.state.top}>
                            <div className="inner">
                                {detailLoaded}
                            </div>
                        </Affix>
                    </Col>
                </Row>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/GeoRegion/GeoRegionIndex.js